export default __webpack_public_path__ + "static/about-2-8caa60ad44a68f267c1f88c11810363f.png";